import { getEncodedUrl } from "@catchoftheday/utilities";
import { URL_ONEPASS_CONSENT, URL_ONEPASS_OAUTH_REDIRECT, URL_ONEPASS_SUBSCRIBE, } from "../consts";
export const generateOnePassLinkingUrl = (url, queryParams) => `${URL_ONEPASS_OAUTH_REDIRECT}?n=1&_destination=${encodeURIComponent(getEncodedUrl(url, {
    showmessage: "l",
    ...queryParams,
}))}`;
export const generateOnePassUpsellUrl = ({ url = "/", cta = "start-free-trial", }) => `${URL_ONEPASS_SUBSCRIBE}?_destination=${getEncodedUrl(url, {
    showmessage: "u",
})}&utm_cta=${cta}`;
export const generateOnePassConsentUrl = (url, queryParams) => {
    const destinationUrl = queryParams && Object.keys(queryParams).length > 0
        ? getEncodedUrl(url, { ...queryParams })
        : url;
    return `${URL_ONEPASS_CONSENT}?_destination=${encodeURIComponent(destinationUrl)}`;
};
